const idGetFull = ( id, prefix ) => ( prefix ? prefix : "" ) + id;

export default {
  itemLifeTimeMs: 365 * 24 * 60 * 60 * 1000,

  
  remove( id, prefix ) {
    const idFull = idGetFull( id, prefix );
    
    window.localStorage.removeItem( idFull );
  },
  
  get( id, prefix ) {
    const idFull = idGetFull( id, prefix );
    
    if ( window.localStorage ) {
      let item = window.localStorage.getItem( idFull );

      try {
        item = JSON.parse( item );
        if ( !( "lastAccess" in item ) || !( "value" in item ) ) throw new Error( "invalid item format" );

        item.lastAccess = Date.now();
        window.localStorage.setItem( idFull, JSON.stringify( item ) );
        
        return item.value;
      }
      catch ( e ) {
        window.localStorage.removeItem( idFull );
      }
    }

    return undefined;
  },
  
  set( id, v, prefix, time ) {
    const idFull = idGetFull( id, prefix );

    if ( window.localStorage ) {
      //storage cleanup => remove old, invalid or empty values
      if ( !Number.isInteger( time ) ) time = Date.now();
      for ( let i = 0; i < window.localStorage.length; i++ ) {
        const key = window.localStorage.key( i );
        if ( key.indexOf( this.prefix ) === 0 ) {
          let v = window.localStorage.getItem( key );
          if ( v ) try { v = JSON.parse( v ); } catch ( e ) {}
          if (
            !v ||
            !Number.isInteger( v.lastAccess ) ||
            v.lastAccess < 0 ||
            ( v.lastAccess !== 0 && ( time - v.lastAccess ) > this.itemLifeTimeMs )
          ) {
            window.localStorage.removeItem( key );
            i--;
          }
        }
      }

      window.localStorage.setItem(
        idFull,
        JSON.stringify(
          {
            lastAccess: time,
            value:      v
          }
        )
      );
    }
  },
  
  setPermanent( id, v, prefix ) {
    return this.set( id, v, prefix, 0 );
  }
}
